import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { CREATE_ENTITLEMENT } from './url-constants';

type CreateEntitlementEndpointSpecification = ApiEndpointSpecification;
export const CreateEntitlementEndpointSpecification: CreateEntitlementEndpointSpecification = {
    url: CREATE_ENTITLEMENT,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'CreateEntitlementRequestParams',
    requestBodySchemaName: 'CreateEntitlementRequestBody',
    okResponseSchemaName: 'CreateEntitlementOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 3.0
};

export const invokeCreateEntitlement = Helpers.makeApiRequestFn<
    Types.CreateEntitlementRequestParams,
    Types.CreateEntitlementRequestBody,
    Types.CreateEntitlementOkResponse
>(CreateEntitlementEndpointSpecification);
